import React from 'react';
import { Popup } from '../../shared/GenericPopup';
import donationImage from '../../../assets/Img/Give-Gift--Streamline-Sharp.png';

interface DonationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  paymentReferenceId: string;
  amount?: number;
  frequency?: string;
}

const DonationSuccessModal: React.FC<DonationSuccessModalProps> = ({
  isOpen,
  onClose,
  email,
  paymentReferenceId,
  amount,
  frequency
}) => {
  if (!isOpen) return null;

  const isRecurring = frequency && frequency !== 'ONETIME';
  const frequencyLabel = frequency === 'MONTHLY' ? 'monthly' : frequency === 'ANNUALLY' ? 'annual' : '';

  const handleReturnHome = () => {
    onClose();
    window.location.href = 'https://stlukehealthcare.org/donate/';
  };

  return (
    <Popup onClose={onClose}>
      <div className="text-center p-6">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center">
            <img
              src={donationImage}
              alt="Donation"
              className="w-12 h-12 object-contain"
            />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-[#153B4E] mb-4">
          Thank you!
        </h1>

        <p className="text-gray-600 mb-6 text-sm">
          {isRecurring ? (
            <>
              Your {frequencyLabel} donation of{' '}
              <span className="font-bold">{amount ? `$${amount.toFixed(2)}` : 'your amount'}</span>{' '}
              has been set up successfully. You will be charged {frequencyLabel} starting from your next billing date.
            </>
          ) : (
            <>
              Your generous donation of{' '}
              <span className="font-bold">{amount ? `$${amount.toFixed(2)}` : 'your amount'}</span>{' '}
              has been processed successfully. Please find the confirmation number below.
            </>
          )}
        </p>

        {!isRecurring && paymentReferenceId && (
          <div className="bg-gray-100 rounded-lg p-4 mb-6">
            <div className="text-gray-600 text-sm mb-2">Confirmation Number</div>
            <div className="text-l font-bold text-[#153B4E]">{paymentReferenceId}</div>
          </div>
        )}

        <p className="text-gray-600 mb-8 text-sm">
          A receipt has been sent to{' '}
          <span className="font-bold">{email}</span>
        </p>

        <button
          onClick={handleReturnHome}
          className="w-full bg-[#153B4E] text-white font-semibold py-3 px-6 rounded-lg text-lg hover:bg-[#0f2a38] transition-colors duration-300"
        >
          Return to Homepage
        </button>
      </div>
    </Popup>
  );
};

export default DonationSuccessModal;
